<script setup lang="ts">
import { onClickOutside } from '@vueuse/core'

import EpIcon from '~/components/icon/EpIcon.vue'
import { DISCLAIMER_TEXT } from '~/constants/terms.constants'
import { routes } from '~/routes'

const showDisclaimer = ref(false)

const setShowDisclaimer = (value: boolean) => {
  showDisclaimer.value = value
}

const disclaimerRef = ref<HTMLElement | null>(null)

onClickOutside(disclaimerRef, () => {
  setShowDisclaimer(false)
})
</script>

<template>
  <footer class="footer-container">
    <span class="text-default/40">Powered by Xangle</span>
    <div
      id="disclaimer-wrapper"
      class="relative flex items-center gap-x-2"
    >
      <NuxtLink
        class="footer-button"
        :to="routes.getTermsPage()"
      >
        Terms of Service
      </NuxtLink>
      <div ref="disclaimerRef">
        <button
          class="footer-button"
          @click="setShowDisclaimer(true)"
        >
          Disclaimer
        </button>
      </div>
    </div>
    <Teleport
      v-if="showDisclaimer"
      to="#disclaimer-wrapper"
    >
      <div class="disclaimer">
        <div class="mb-2.5 flex items-center justify-between text-xs">
          <span class="text-base font-bold">Disclaimer</span>
          <button
            class="p-2"
            @click="setShowDisclaimer(false)"
          >
            <EpIcon
              name="close"
              :size="20"
            />
          </button>
        </div>
        {{ DISCLAIMER_TEXT }}
      </div>
    </Teleport>
  </footer>
</template>

<style scoped lang="scss">
.footer-container {
  @apply flex w-full items-center justify-between px-2 py-4 gap-y-2;

  @include mobile {
    @apply flex-col;
  }
}

.footer-button {
  @apply font-bold text-primary p-2 text-sm;
}

.disclaimer {
  @apply absolute bottom-[calc(100%+8px)] right-0 w-[50vw] bg-primary/5 p-4 text-primary backdrop-blur-3xl z-[100];

  @include mobile {
    @apply w-[90vw] left-1/2 -translate-x-1/2;
  }
}
</style>